import { render, staticRenderFns } from "./veSbzcZcPurchaseEdit.vue?vue&type=template&id=709cc0d8&scoped=true"
import script from "./veSbzcZcPurchaseEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcZcPurchaseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709cc0d8",
  null
  
)

export default component.exports